import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
    pulleys: [],
    totalWeight: 0,
}

const pulleySlice = createSlice({
    name: 'pulley',
    initialState,
    reducers: {
        initialize: state => initialState,
        changeField: (state, { payload: { form, key, value } }) => {
            state.pulleys[form][key] = value;
        },
        addPulley: (state) => {
            state.push({
                id: '',
                type: '',
            })
        },
        removePulley: (state, action) => {
            const index = action.payload;
            if (index >= 0 && index < state.pulleys.length) {
                state.pulleys.splice(index, 1);
            }
        }
    },
});

// 액션과 리듀서 내보내기
export const { initialize, changeField, addPulley, removePulley } = pulleySlice.actions;
export default pulleySlice.reucer;
